export default {
    addContact: (state, {id, data}) => {
        state.contacts[id] = data
    }
}
